const dev = {
    hideSignUp: false,
    //authEnabled: true,
    APIDomain: 'https://0gmvbycxcj.execute-api.eu-west-1.amazonaws.com/dev'
  };
  
  export default dev;
  